var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { style: { display: "block" }, attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title.edit-group")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("label.name") },
                    model: {
                      value: _vm.value.Name,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Name", $$v)
                      },
                      expression: "value.Name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("app-color-picker", {
                    key: _vm.pickerKey,
                    attrs: {
                      color: _vm.value.Color,
                      label: _vm.$ct("label.color"),
                      "preset-colors": ["#f00", "#00ff00", "#00ff0055"],
                      compact: true,
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.Color,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "Color", $$v)
                      },
                      expression: "value.Color",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.value.Color
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { sm: "12" } },
                    [
                      _c(
                        "w-link",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.clearColor()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$ct("no-color")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel mr",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.$emit("cancel")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          !_vm.isNew
            ? _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "trash" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("delete")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.delete")))]
              )
            : _vm._e(),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "save", disabled: !_vm.value.Name },
              on: {
                click: function ($event) {
                  return _vm.$emit("save", _vm.value)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }